import {
  bookingApi,
  bookingOcicoApi,
  contentApi,
  MyReservationsDirectory
} from '@/infrastructure/Configuration'
import { transactionService } from '@/infrastructure/Factory'
import { uniqueValues } from '@/infrastructure/Utils'
export default class MyReservationsService {
  constructor(httpClient) {
    this.httpClient = httpClient
    this.transactionIds = {}
  }

  async getReservations({ memberType, groupType, page, limit }) {
    const limitToDisplay = limit || MyReservationsDirectory.LIMIT
    const order = groupType === 'future' ? 'asc' : 'desc'
    const url = `${bookingApi}/bookings/${groupType}?type=${
      memberType !== undefined ? memberType : ''
    }&offset=${page !== undefined ? page : '0'}&limit=${
      limitToDisplay !== undefined ? limit : ''
    }&order=${order}`
    const transactionId =
      this.transactionIds[memberType + '_' + groupType] || transactionService.generate()
    this.transactionIds[memberType + '_' + groupType] = transactionId
    const config = {
      headers: { TransactionID: transactionId }
    }

    try {
      const { data } = await this.httpClient.get(url, config)
      return this.getReservationInfo(data.bookings, page, limitToDisplay, data.total)
    } catch (error) {
      return {}
    }
  }

  async getNewReservations({ memberType, groupType, page, limit, firstName, lastName }) {
    const limitToDisplay = limit || MyReservationsDirectory.LIMIT
    const order =
      groupType === 'future' || groupType === 'active' || groupType === 'near-and-far'
        ? 'asc'
        : 'desc'
    const url = `${bookingApi}/bookings/${groupType}?type=${
      memberType !== undefined ? memberType : ''
    }&offset=${page !== undefined ? page : '0'}&limit=${
      limitToDisplay !== undefined ? limit : ''
    }&order=${order}&firstName=${firstName !== undefined ? firstName : ''}&lastName=${
      lastName !== undefined ? lastName : ''
    }`
    const transactionId =
      this.transactionIds[memberType + '_' + groupType] || transactionService.generate()
    this.transactionIds[memberType + '_' + groupType] = transactionId
    const config = {
      headers: { TransactionID: transactionId }
    }

    try {
      const { data } = await this.httpClient.get(url, config)
      return { count: data.total, reservations: data.bookings }
    } catch (error) {
      return { count: 0, reservations: [] }
    }
  }

  async getHotels(hotelCodes) {
    if (hotelCodes.length === 0) return []

    const params = {
      hotelCodes: hotelCodes.join(',')
    }
    const url = `${contentApi}/hotels`
    const response = await this.httpClient.get(url, { params })

    return response.data.hotels
  }

  async getOciId(name, lastName, bookingId) {
    const data = {
      name,
      lastName,
      bookingId
    }
    try {
      const url = `${bookingOcicoApi}/check-in`
      const response = await this.httpClient.post(url, data)

      return response.data.ociId
    } catch (error) {
      return ''
    }
  }

  async getOcoId(roomNumber, lastName, hotelCode) {
    const data = {
      roomNumber,
      lastName,
      hotelCode
    }
    try {
      const url = `${bookingOcicoApi}/check-out`
      const response = await this.httpClient.post(url, data)

      return response.data.ocoId
    } catch (error) {
      return ''
    }
  }

  async getBookingCheckInfo(reservations, totalReservations, groupType) {
    if (groupType !== 'past' && reservations[0]) {
      try {
        const reservationssWithBookingCheckInfo = reservations.map(reservation => ({
          ...reservation
        }))
        return {
          count: totalReservations,
          reservations: reservationssWithBookingCheckInfo
        }
      } catch (error) {
        return { count: totalReservations, reservations }
      }
    } else {
      return { count: totalReservations, reservations }
    }
  }

  async getReservationInfo(reservations, page, displayLimit, totalReservations) {
    const hotelCodes = reservations.map(reservation => reservation.hotelCode).filter(uniqueValues)
    const hotels = await this.getHotels(hotelCodes)
    // TO DO: bookingApi should return hotelCode from XBS no TMS, then hotel.tmsCode should be hotel.code
    const enrichedReservationsWithHotelInfo = reservations.map(reservation => ({
      ...reservation,
      hotel: hotels.find(hotel => hotel.tmsCode === reservation.hotelCode)
    }))

    return {
      count: totalReservations,
      reservations: enrichedReservationsWithHotelInfo
    }
  }

  async getExploreHotel(hotelCode) {
    const url = `${contentApi}/reservations/${hotelCode}/explore-module`
    const { data } = await this.httpClient.get(url)
    return data
  }

  async getNoReservations(memberType) {
    const url = `${contentApi}/reservations/no-reservations-module?memberType=${
      memberType !== undefined ? memberType : ''
    }`
    const { data } = await this.httpClient.get(url)
    return data
  }

  async sendInvoice(payload) {
    const url = `${bookingApi}/invoice/send`
    const response = await this.httpClient.put(url, payload)
    return response.data
  }
}
